<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $tc("add") }} {{ $tc("movie_label", 1) }}
      </div>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="label_name"
                type="text"
                name="labelname"
                id="labelname"
                v-validate="'required'"
              />
              <label>{{ $t("label") }} {{ $t("name") }}</label>
            </div>
            <Tooltip :title="$t('movie_label_tooltip')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('labelname')">{{
              errors.first("labelname")
            }}</span>
          </p>
        </div>
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="label_short_code"
                type="text"
                name="labelshortname"
                id="labelshortname"
                v-validate=""
              />
              <label
                >{{ $t("label") }} {{ $t("short") }} {{ $t("name") }}</label
              >
            </div>
            <Tooltip :title="$t('label_short_name_tooltip')" />
          </div>
          <p class="error_message"></p>
        </div>

        <div v-if="false" class="col-lg-6 col-xl-4 align-self-center mb-5">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label :class="selectedType ? 'shift-up' : ''">{{$t('ml_type_label')}}</label>
              <multiselect
                      v-model="selectedType"
                      @select="onSelectType($event)"
                      :placeholder="'Select Label Type'"
                      :options="TypeList"
                      label="name"
                      track-by="type_id"
                      :multiple="false"
                      name="mltype"
                      id="mltype"
                      select-label="Select"
                      deselect-label="Remove"
                    ></multiselect>
            </div>
          </div>
        </div> 
        

        <div class="col-lg-6 col-xl-4 align-self-center mb-5">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">Active</label>
            <b-form-checkbox
              unchecked-value="N"
              value="Y"
              v-model="label_is_active"
              name="check-button"
              switch
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-12">
          <h5 class="mb-2">Translations</h5>
          <div class="row">
            <div
              class="col-lg-6 col-xl-4 align-self-center mb-4"
              v-for="(language, langIndex) in languagesToShow"
              :key="langIndex"
            >
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    type="text"
                    name="en-trans"
                    v-model="language.label_name"
                    placeholder="."
                  />
                  <label>{{ language.lang_name }}</label>
                </div>
                <Tooltip :title="`Enter ${language.lang_name} Translation`" />
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="movie-labels"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import MovieService from "@/services/MovieService";
import TranslationsContainer from "@/components/Partials/translationsFields.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    TranslationsContainer
  },
  data() {
    return {
      TypeList: [
        {
          type_id: 1,
          name: 'Movie Labels'
        },
        {
          type_id: 2,
          name: 'Home Labels'
        }
      ],
      selectedType:  {
          type_id: 1,
          name: 'Movie Labels'
        },
      btenable: false,
      label_name: "",
      ml_type: 1,
      label_short_code: "",
      label_is_active: "Y",
      submitted: false,
      ContentLanguages: [],
      LabelContent: []
    };
  },
  computed: {
    ...mapGetters(["getGlobalOptions"]),
    languagesToShow: function() {
      let languages = [];
      if (this.getGlobalOptions && this.getGlobalOptions.length > 0) {
        let kiosk_langs_obj = this.getGlobalOptions.find(
          x => x.go_key === "KIOSK_LANGUAGE"
        );

        if (kiosk_langs_obj) {
          try {
            let kiosk_langs = JSON.parse(kiosk_langs_obj.go_value);

            if (kiosk_langs && kiosk_langs.length > 0) {
              languages = kiosk_langs
                .filter(x => x.lang_name && x.iso_2)
                .map(x => ({
                  lang_name: x.lang_name,
                  lang_id: x.lang_id,
                  iso_2: x.iso_2.toLowerCase(),
                  label_name: ""
                }));
            }
          } catch (err) {
            console.log("error in parsing kiosk languages");
          }
        }
      }

      console.log("languagesToShow =>>> ", languages);

      return languages;
    }
  },
  beforeMount() {
    this.selectedType = this.TypeList.find((x) => x.type_id == 1);
    console.log("this.selectedType", this.selectedType);
  },
  mounted() {
  },
  methods: {
    onSelectType(type) {
      this.ml_type = type.type_id;
      this.selectedType = type;
    },
    OnFinalSubmit: function(redirect) {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          if(!this.selectedType) {
            return this.$toasted.show('Please Select Label Type');
          } else{
          let payload = {
            label_name: this.label_name,
            label_short_code: this.label_short_code,
            label_is_active: this.label_is_active,
            ml_type: this.ml_type,
            LabelContent: this.languagesToShow
          };
          MasterService.AddLabel(payload)
            .then(response => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.resetForm();
                if (redirect) {
                  this.$router.push({
                    path: "/master/movie-labels"
                  });
                }
                this.submitted = false;
                this.$toasted.show(data.message);
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch((err) => {
              console.log("Error:", err);
            });
        }
        }
      });
    },
    resetForm: function() {
      this.label_name = "";
      this.label_is_active = "Y";
      this.label_short_code = "";
      this.languagesToShow.map(x => {
        x.label_name = "";
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/MovieLabelComponents/addMovieLabel.vue